import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import PrimeVue from "primevue/config";
import "./assets/css/lara-light-purple/theme.css";
import ToastService from "primevue/toastservice";
import Tooltip from 'primevue/tooltip';
import moment from "moment";
import HighchartsVue from "highcharts-vue";
// import exportingInit from 'highcharts/modules/exporting';
// import exportDataInit from 'highcharts/modules/export-data';
// exportingInit(Highcharts);
// exportDataInit(Highcharts);
// import exportingInit from 'highcharts/modules/exporting';
// import offlineExportingInit from 'highcharts/modules/offline-exporting'; // Para exportación en el cliente
// import exportDataInit from 'highcharts/modules/export-data';
// exportingInit(HighchartsVue);
// offlineExportingInit(HighchartsVue);
// exportDataInit(HighchartsVue);
// import 'primeicons/primeicons.css'
// import 'primevue/resources/themes/saga-blue/theme.css'; // o cualquier otro tema que estés usando
// import 'primevue/resources/themes/lara-light-purple/theme.css'; // o cualquier otro tema que estés usando
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

moment.locale("es");
const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
// appInstance.config.globalProperties.$isDemo = process.env.VUE_APP_IS_DEMO || 0;
appInstance.use(PrimeVue);
appInstance.use(ToastService);
appInstance.directive('tooltip', Tooltip);
// appInstance.use(require("vue-moment"));
appInstance.use(moment);
appInstance.use(HighchartsVue);
appInstance.mount("#app");
